<template>
  <div class="project-layout">
    <!-- 左侧 -->
    <aside-menu @updateFlod="handleUpdateFlod"></aside-menu>
    <!-- 右侧（水印） -->
    <div
      class="right-content"
      :key="waterKey"
      v-watermark="{ text: waterMark, fontSize: 14, color: 'rgba(150,150,150,0.5)' }"
    >
      <tabs-layout style="margin-left: 38px; height: 40px; width: calc(100% - 38px)" :nickName="nickName"></tabs-layout>
      <keep-alive :include="cachedViews">
        <router-view class="main-content"></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import AsideMenu from '@/components/AsideMenu/AsideMenu.vue';
import TabsLayout from '@/layout/TabsLayout.vue';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      menuFlod: true,
      waterKey: 0
    };
  },
  components: {
    AsideMenu,
    TabsLayout
  },
  computed: {
    cachedViews() {
      return this.$store.state.app.cachedViews;
    },
    ...mapState({
      nickName: (state) => {
        return state.login.user.nickName;
      },
      waterMark: (state) => {
        return state.login.user.nickName + '' + state.login.user.phonenumber;
      }
    })
  },
  methods: {
    handleUpdateFlod(val) {
      this.menuFlod = val;
    },
    handleTabsEdit(targetName, action) {
      if (action === 'add') {
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.push({
          title: 'New Tab',
          name: newTabName,
          content: 'New Tab content'
        });
        this.editableTabsValue = newTabName;
      }
      if (action === 'remove') {
        if (this.editableTabs.length <= 1) {
          this.$message('至少保留一个页签打开');
          return;
        }
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      }
    },
    // 获取用户信息，水印显示用户名和电话
    async getUserInfo(params) {
      const res = await this.$store.dispatch('login/getInfo');
      if (res?.data?.user) {
        let userInfo = res.data.user;
        this.nickName = userInfo.nickName;
        let phone = userInfo.phonenumber;
        this.waterMark = this.nickName + ' ' + phone;
        this.waterKey = Math.random(); //通过改变组件的key属性来强制Vue重新创建组件实例。
      }
    }
  },
  mounted() {
    // this.getUserInfo();
  }
};
</script>

<style lang="scss" scoped>
.project-layout {
  display: flex;
  width: 100%;
  height: 100%;
}
.right-content {
  width: calc(100% - 210px);
  height: 100%;
  // margin-left: -38px;
}
.right-content-width {
  width: calc(100% - 64px);
  height: 100%;
  margin-left: -38px;
}
::v-deep .main-content {
  background-image: url('../assets/images/contentBg.png');
  background-size: 100% 100%;
  padding: 0 10px 10px;
  .el-form {
    background: #fff;
    padding: 15px;
  }
}
::v-deep .el-tabs__item {
  height: 35px;
  line-height: 35px;
  margin-top: 5px;
}
.el-tabs__item.is-active {
  color: #3083fb;
}
.el-tabs__header {
  margin: 0;
}
</style>
